import { Badge, Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import InputNumeric from "../../../components/Forms/Element/InputNumeric";
import BranchSelect from "../../../components/Custom/Main/Branch/BranchSelect";
import ProductSelect from "../../../components/Custom/Main/Product/ProductSelect";
import { getUnitLabel, formatQuantityByUnit } from "../../../../utils/unitMeasure";

const Form = (props) => {

    const { t } = useTranslation();
    const { formik, entityData } = props;
    const [disabledFields, setDisabledFields] = useState(false);
    const [unitLabel, setUnitLabel] = useState('');
    const [stockStatus, setStockStatus] = useState({ level: '', icon: '', color: '' });

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('minStockLevel', entityData.minStockLevel);
            formik.setFieldValue('currentStock', formatQuantityByUnit(entityData.qty, entityData.product.unit));
            formik.setFieldValue('product', { value: entityData.product.id, label: entityData.product.name });
            formik.setFieldValue('branch', { value: entityData.branch.id, label: entityData.branch.name });
            
            // Define a unidade de medida
            if (entityData.product.unit) {
                setUnitLabel(getUnitLabel(entityData.product.unit, t));
            }

            // Define o status do estoque
            if (entityData.qty === 0) {
                setStockStatus({ 
                    level: t('out_of_stock'), 
                    icon: 'fa-solid fa-siren-on fa-beat', 
                    color: 'danger' 
                });
            } else if (entityData.qty < entityData.minStockLevel) {
                setStockStatus({ 
                    level: t('low_stock'), 
                    icon: 'fas fa-exclamation-triangle', 
                    color: 'warning' 
                });
            } else {
                setStockStatus({ 
                    level: t('normal_stock'), 
                    icon: 'fas fa-check-circle', 
                    color: 'success' 
                });
            }
            
            setDisabledFields(true);
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <div className="form-layout__panel">
                    <div className="form-layout__panel-header">
                        <div>
                            <h5 className="mb-1">{t('product_information')}</h5>
                            <p className="mb-0">{t('stock_product_information_hint')}</p>
                        </div>
                    </div>

                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('product')}</FormLabel>
                                <ProductSelect
                                    name="product"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.product}
                                    error={formik.errors.product}
                                    isDisabled={disabledFields}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('branch')}</FormLabel>
                                <BranchSelect
                                    name="branch"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.branch}
                                    error={formik.errors.branch}
                                    isDisabled={disabledFields}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>

                <div className="form-layout__panel">
                    <div className="form-layout__panel-header">
                        <div>
                            <h5 className="mb-1">{t('stock_management')}</h5>
                            <p className="mb-0">{t('stock_management_form_hint')}</p>
                        </div>
                        {stockStatus.level && (
                            <Badge bg={stockStatus.color} className="d-flex align-items-center ms-3">
                                <i className={`${stockStatus.icon} me-1`}></i>
                                {stockStatus.level}
                            </Badge>
                        )}
                    </div>

                    <div className="alert alert-info border-0 mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        {t('message.minimum_stock_edit')}
                    </div>

                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>
                                    {t('current_stock')} {unitLabel && `(${unitLabel})`}
                                </FormLabel>
                                <InputText
                                    name="currentStock"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.currentStock}
                                    error={formik.errors.currentStock}
                                    disabled={disabledFields}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>
                                    <i className="fas fa-exclamation-triangle text-warning me-1"></i>
                                    {t('min_stock_level')} {unitLabel && `(${unitLabel})`}
                                </FormLabel>
                                <InputNumeric
                                    name="minStockLevel"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.minStockLevel}
                                    error={formik.errors.minStockLevel}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default Form;
